import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import BenevolCheckLogo from '../components/BenevolCheckLogo';

const CGUPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header */}
      <header className="container mx-auto px-4 py-6">
        <Link to="/" className="flex items-center gap-3">
          <BenevolCheckLogo size="sm" />
        </Link>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <Card className="shadow-lg">
          <CardHeader>
            <CardTitle className="text-2xl text-indigo-900">Conditions Générales d'Utilisation</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">Dernière mise à jour : Janvier 2025</p>

            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">1. Objet</h2>
              <p>
                Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation 
                de la plateforme Bénévol'Check, service proposé par France Bénévolat Côte d'Or pour la 
                gestion et la délivrance d'attestations de compétences bénévoles.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">2. Définitions</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Plateforme</strong> : le site web Bénévol'Check accessible à l'adresse benevolcheck.fr</li>
                <li><strong>Utilisateur</strong> : toute personne physique accédant à la plateforme</li>
                <li><strong>Bénévole</strong> : utilisateur inscrit en tant que bénévole</li>
                <li><strong>Association</strong> : organisme à but non lucratif inscrit sur la plateforme</li>
                <li><strong>Attestation</strong> : document certifiant les compétences acquises par un bénévole</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">3. Inscription et compte utilisateur</h2>
              <p>
                L'utilisation de Bénévol'Check nécessite la création d'un compte. L'utilisateur s'engage à 
                fournir des informations exactes et à maintenir la confidentialité de ses identifiants de connexion.
              </p>
              <p className="mt-2">
                Les associations doivent s'acquitter d'une cotisation annuelle de 10€ pour activer leur compte.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">4. Utilisation du service</h2>
              <p>La plateforme permet :</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Aux bénévoles : de créer des demandes d'attestation et de consulter leurs attestations validées</li>
                <li>Aux associations : de valider les attestations et de gérer les compétences de leurs bénévoles</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">5. Protection des données personnelles</h2>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD), les données 
                personnelles collectées sont traitées de manière confidentielle et sécurisée. 
                Les utilisateurs disposent d'un droit d'accès, de rectification et de suppression de leurs données.
              </p>
              <p className="mt-2">
                Pour exercer ces droits, contactez-nous à : <a href="mailto:benevolcheck@francebenevolat.org" className="text-indigo-600 hover:underline">benevolcheck@francebenevolat.org</a>
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">6. Propriété intellectuelle</h2>
              <p>
                L'ensemble des éléments de la plateforme (logo, design, textes) sont la propriété de 
                France Bénévolat et sont protégés par les lois relatives à la propriété intellectuelle.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">7. Responsabilité</h2>
              <p>
                France Bénévolat Côte d'Or s'efforce d'assurer la disponibilité de la plateforme mais ne 
                peut garantir un fonctionnement sans interruption. L'utilisateur est seul responsable de 
                l'exactitude des informations qu'il renseigne.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">8. Modification des CGU</h2>
              <p>
                France Bénévolat se réserve le droit de modifier les présentes CGU à tout moment. 
                Les utilisateurs seront informés de toute modification substantielle.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">9. Contact</h2>
              <p>
                Pour toute question relative aux présentes CGU, contactez-nous :
              </p>
              <p className="mt-2">
                France Bénévolat Côte d'Or<br />
                Maison des Associations<br />
                2 rue des Corroyeurs, 21000 Dijon<br />
                Email : <a href="mailto:cotedor@francebenevolat.org" className="text-indigo-600 hover:underline">cotedor@francebenevolat.org</a>
              </p>
            </section>

            <div className="pt-6">
              <Link to="/">
                <Button variant="outline">← Retour à l'accueil</Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </main>

      {/* Footer */}
      <footer className="bg-indigo-900 text-white mt-16 py-6">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">&copy; 2025 Bénévol'Check - Propulsé par France Bénévolat avec l'aide du SDJES Côte d'Or</p>
        </div>
      </footer>
    </div>
  );
};

export default CGUPage;
